import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import SelectedMultipleDepartmentsList from "../../../../components/common/modals/multipleDepartmentsModal/SelectedMultipleDepartmentsList";
import MultipleTogglePopup from "../../../../components/common/modals/multipleDepartmentsModal/MultipleTogglePopup";
import MultiUsersModal from "./MultiUsersSteps";
import SelectedMultipleUsersList from "../../../../components/common/modals/multipleUsersModal/SelectedMultipleUsersList";
import { useFormikContext } from "formik";
import { updateReferrals } from "../../../../utils";

const AddMultipleUsersBranchDep = ({
  mainParents,
  title,
  icon,
  selPlaceholder,
  setSelectedIds,
  selectedIds,
  hqBranchesList,
  branchesDeps,
  usersList,
  userSelections,
  setUserSelections,
  checkedUsers,
  onFormChange,
  setValue,
  checkedHqBranches,
}) => {
  const { t, i18n } = useTranslation();
  const { setFieldValue, values } = useFormikContext();

  const [selectedMainParents, setSelectedMainParents] = useState([]);
  const [showMultipleDepartmentsModal, setShowMultipleDepartmentsModal] =
    useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const formatHqList = hqBranchesList.map((item) => ({
    ...item,
    id: item.id,
    name: i18n.language === "en" ? item.name_en : item.name_ar,
  }));

  const handleRemoveClick = (userId) => {
    const updatedUsers = selectedUsers.filter((user) => user.id !== userId);
    const updatedIds = updatedUsers.map((user) => user.id);

    if(setFieldValue){
      const updatedReferrals = values.referrals?.filter((ref) => ref.unique_id !== `other_department_${userId}`);
      setFieldValue('referrals', updatedReferrals);
    }

    setSelectedUsers(updatedUsers);
    setUserSelections({
      ...userSelections,
      user_ids: updatedIds,
    });
    if (typeof setSelectedIds === "function") {
        setSelectedIds(updatedIds);
    }

    if (typeof setValue === "function") {
      setValue("selected_ids", updatedIds, { shouldValidate: true });
    }

    if (typeof onFormChange === "function") {
      onFormChange(updatedIds);
    }
  };

  const handleAddItems = (newData) => {
    const updatedIds = newData.map((x) => x.id);
    setSelectedMainParents(newData);
    setSelectedIds(updatedIds);
  };

  useEffect(() => {
    if (selectedIds && mainParents?.length > 0) {
      const selectedItems = mainParents.filter((item) =>
        selectedIds.includes(parseInt(item.id))
      );
      setSelectedMainParents(selectedItems);
    }
  }, [selectedIds, mainParents]);

  useEffect(() => {
    if (checkedUsers && checkedUsers?.length > 0) {
      setSelectedUsers(checkedUsers);

      setUserSelections((prev) => ({
        ...prev,
        user_ids: checkedUsers?.map((user) => user.id),
      }));
    }
  }, [checkedUsers]);

  const handleUsersSelection = (newlySelectedUsers) => {
    const merged = [...selectedUsers];

    newlySelectedUsers.forEach((newUser) => {
      if (!merged.some((user) => user.id === newUser.id)) {
        merged.push(newUser);
      }
    });

    setSelectedUsers(merged);

    setUserSelections((prev) => ({
      ...prev,
      user_ids: merged.map((user) => user.id),
    }));

    if(setFieldValue) {
      const referralArray = updateReferrals(merged, 'other_department', values.referrals);
      setFieldValue('referrals', referralArray);
    };
  };

  return (
    <MultipleDepartmentsRow>
      <SelectedMultipleUsersList
        selectedMainParents={selectedUsers}
        onRemoveClick={handleRemoveClick}
      />
      <MultipleTogglePopup
        icon={icon}
        selPlaceholder={t(selPlaceholder)}
        setShowMultipleDepartmentsModal={setShowMultipleDepartmentsModal}
      />
      <MultiUsersModal
        title={t(title)}
        show={showMultipleDepartmentsModal}
        onHide={() => setShowMultipleDepartmentsModal(false)}
        mainParents={mainParents}
        selectedMainParents={selectedMainParents}
        setSelectedMainParents={handleAddItems}
        branches={formatHqList}
        departments={branchesDeps}
        users={usersList}
        setSelections={setUserSelections}
        selections={userSelections}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        onUsersSelected={handleUsersSelection}
        checkedBranchIds={checkedHqBranches?.branchIds || []}
        checkedDepartmentIds={checkedHqBranches?.depIds || []}
      />
    </MultipleDepartmentsRow>
  );
};

export default AddMultipleUsersBranchDep;

const MultipleDepartmentsRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
